import { render } from "./IconCheckVar.vue?vue&type=template&id=53165bec&ts=true"
import script from "./IconCheckVar.vue?vue&type=script&lang=ts"
export * from "./IconCheckVar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__